export default __webpack_public_path__ + "static/media/Modal-close-img.3f496fc7.svg";